import SelectorEngine from '../../utils/dom/selector-engine';
import EventHandler from '../../utils/dom/event-handler';
import FormComponent from '../FormComponent';
import AffiliatedVenueSearch from '../AffiliatedVenueSearch';
import uuid from '../../../vendors/FormValidation/validators/uuid';

const CLICK_EVENT = 'click';

const SEARCH_QUESTION_DATA = {
	placeHolder: 'Search for your venue',
	errorMessage: 'Please select the name of your venue',
	fieldName: 'venue',
	questionType: 'coachVenueSearch',
	dependentQuestion: [3],
	visible: false,
	hasLimit: true,
	charLimit: 3,
	minSearchChar: 3,
	apiEndpoint: '/api/coachdetails/searchAffiliatedVenuesByName',
	paramName: 'venue',
	apiResponseKey: 'affiliatedvenues',
	dataKey: 'id',
	dataEventName: 'venueSelect',
	valueKey: 'venue'
};

class AffiliatedVenueSearchList extends FormComponent {
	// eslint-disable-next-line no-useless-constructor
	constructor(containerElement, data) {
		super(containerElement, data);
	}

	markup(value, rowData, titleMarkup) {
		const labelData = rowData?.instructionText
			? `<label class="lta-text-input__label u-text-grey-lta lta-heading-subtitle u-mb-1">${rowData?.instructionText}</label>`
			: '';
		return `
            <div class="lta-affiliated-venue-search-list u-mb-5">
				<div class="lta-affiliated-venue-search-list-title">${titleMarkup}</div>
				${labelData}
                <div class="lta-affiliated-venue-search-list-wrapper">
				</div>
				<button type="button" class="lta-btn lta-btn--md lta-btn--line u-px-6 u-w-100 lta-affiliated-venue-search-list-venue-add">+ Add another venue</button>
            </div>
        `;
	}

	afterRender() {
		this.affiliatedVenueSearchListElement = SelectorEngine.findOne(
			`.lta-affiliated-venue-search-list`,
			this.containerEl
		);
		this.listWrapperElement = SelectorEngine.findOne(
			`.lta-affiliated-venue-search-list-wrapper`,
			this.affiliatedVenueSearchListElement
		);
		this.addAnotherVenueButton = SelectorEngine.findOne(
			'.lta-affiliated-venue-search-list-venue-add',
			this.affiliatedVenueSearchListElement
		);

		EventHandler.on(this.addAnotherVenueButton, CLICK_EVENT, () => {
			this.addNewVenue();
		});

		this.venueData = [];
		this.venueRefs = [];
		this.totalVenues = 0;

		if (this.data?.myAffiliatedVenues?.length > 0) {
			this.totalVenues = this.data?.myAffiliatedVenues?.length;
			for (let index = 0; index < this.data?.myAffiliatedVenues?.length; index++) {
				this.venueData[index] = {
					...this.data?.myAffiliatedVenues[index],
					venueID: this.data?.myAffiliatedVenues[index].id,
					...SEARCH_QUESTION_DATA
				};
				this.createAffiliateVenueSearch(this.venueData[index], index + 1);
			}
		} else {
			this.addNewVenue();
		}
	}

	createAffiliateVenueSearch(data, index) {
		const affiliatedVenue = new AffiliatedVenueSearch(this.listWrapperElement, {
			data: {
				...data,
				uid: uuid(),
				id: index
			}
		});
		affiliatedVenue.onRemoveCard((venueID, dataObject) => {
			const indexToRemove = this.venueData?.findIndex((item) => item.venueID === venueID);
			if(this.venueData[indexToRemove]) {
				this.venueData[indexToRemove].operation = "remove";
			}
			this.removeVenueID(dataObject.uid);
		});
		affiliatedVenue.onRoleChange((dataObject) => {
			this.venueData?.map((item) => {
				if (item?.venueID === dataObject?.venueID) {
					item.role = dataObject?.label;
					item.operation = "add";
				}
				return item;
			});
		});
		affiliatedVenue.onAddCard((dataObject) => {
			const valueObject = {
				...dataObject,
				...SEARCH_QUESTION_DATA,
				venueID: dataObject.id,
				operation: "add"
			};
			this.venueData.push(valueObject);
		});
		this.venueRefs[this.venueRefs.length] = affiliatedVenue;
	}

	addNewVenue() {
		this.totalVenues += 1;
		this.createAffiliateVenueSearch({ redirectURL: this.data?.redirectURL, ...SEARCH_QUESTION_DATA }, this.totalVenues);
	}

	removeVenueID(id) {
		const foundVenueReferenceIndex = this.venueRefs.findIndex((item) => item.data.uid === id);
		this.venueRefs?.splice(foundVenueReferenceIndex, 1);
	}

	validate() {
		for (let index = 0; index < this.venueRefs?.length; index++) {
			if (!this.venueRefs[index].validate()) {
				return false;
			}
		}
		this.setupValueObject(this.venueData);
		return true;
	}

	setupValueObject(venueData) {
		this.value = {
			...this.data,
			value: venueData?.length > 0 ? venueData : []
		};
		if (this.value) {
			this.dependentQuestion = this.value.dependentQuestion;
		}
	}
}
export default AffiliatedVenueSearchList;
